function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ReportTabGeneral from '@/modules/tasks/powerbi/components/report/ReportTabGeneral.vue';
import ReportTabPage from '@/modules/tasks/powerbi/components/report/ReportTabPage';
import ReportTabBusinessTerm from '@/modules/tasks/powerbi/components/report/ReportTabBusinessTerm';
import TabHistoryLogView from '@/components/tableau/TabHistoryLogView';
import DatasetTabUser from '@/modules/tasks/powerbi/components/DatasetTabUser.vue';
import ReportTabLineage from '@/modules/tasks/powerbi/components/report/ReportTabLineage.vue';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW, GA_EVENTS } from '@/js/constants';
import tasks from '@/js/tasks';
import { mapState } from 'vuex';
export default {
  name: 'FormMetaReport',
  components: {
    ReportTabGeneral: ReportTabGeneral,
    ReportTabPage: ReportTabPage,
    DatasetTabUser: DatasetTabUser,
    ReportTabBusinessTerm: ReportTabBusinessTerm,
    TabHistoryLogView: TabHistoryLogView,
    ReportTabLineage: ReportTabLineage
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    report_id: {
      type: String,
      default: ''
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      email_regex: new RegExp("[a-z0-9]+@[a-z]+\.[a-z]{2,3}\.[a-z]{2,3}"),
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      response_text: '',
      showDownloadCsv: true,
      showBtnAceptar: true,
      txtCancelar: 'Cancel',
      environt_initial: '',
      objetoInicial: null,
      valid: {
        organization: true,
        data_operator: true,
        kdomain: true,
        ksubdomain: true,
        object_description: true,
        response_text: true
      },
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      tabActive: 'GENERAL',
      tab: null,
      validform: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    isShowWorkFlow: function isShowWorkFlow() {
      return this.isChangeRequest === 'APPROVE_OWNER';
    },
    composeName: function composeName() {
      return "REPORT: ".concat(this.item.path_name, "/").concat(this.item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
    }
  }),
  created: function created() {
    this.environt_initial = this.item['environment'];
    this.objetoInicial = JSON.parse(JSON.stringify(this.item));
    this.getReportById();
  },
  methods: {
    onShowDataset: function onShowDataset(item) {
      this.$emit("onShowDataset", item);
    },
    getReportById: function getReportById() {
      var _this = this;
      var param = {
        report_id: this.report_id
      };
      BiReportService.getReportById(param).then(function (datos) {
        //this.$emit('update:item.business_terms', datos.data.business_terms)
        _this.item.bussines_terms = datos.data.bussines_terms;
      });
    },
    onCancel: function onCancel() {
      this.$emit('onCloseModal', this.item.report_id);
    },
    onReject: function onReject() {
      var _this2 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Response reason';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response: this.ds_response_text,
        domain: window.userInfo.domain
      }, this.item), {}, {
        status: 'REJECTED',
        type_flow: this.isChangeRequest
      }, this.document_id);
      BiReportService.reportSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          if (_this2.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.OWNERSHIP,
              object: 'pbi_report',
              domain_object: _this2.item.domain_org,
              operator: _this2.stringToHash(_this2.item.data_operator),
              company_code: _this2.companyCode,
              id_object: _this2.item.object_name,
              hash_email: _this2.stringToHash(userInfo.email),
              module: 'data_platform',
              status: 'rejected'
            });
          }
          tasks.toast.success('Solicitud rechazada correctamente.');
          _this2.onCancel();
        } else {
          tasks.toast.error(res.message);
        }
      });
    },
    onSave: function onSave() {
      var _this3 = this;
      var formElement = this.$refs.form;
      console.log("form:", formElement.validate());
      console.log("tipo:", this.isChangeRequest);
      if (formElement.validate()) {
        if (this.isChangeRequest === ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR) {
          if (this.item.environment === ENVIRONMENT_FLOW.DEV) {
            var report = {
              domain: window.userInfo.domain,
              report: this.item
            };
            BiReportService.reportAddUpdate(report).then(function (res) {
              _this3.isSend = false;
              console.log('res: ', res);
              if (res && res.code === 200) {
                if (res.success) {
                  tasks.toast.success("Report fields updated!");
                  //this.$toast.success('Report fields updated!')
                  _this3.onCancel();
                  _this3.$emit('onSave', report.report);
                } else {
                  tasks.toast.error(res.message);
                  //this.$toast.warning(res.message)
                  _this3.onCancel();
                }
              }
            });
          } else {
            var _report = {
              domain: window.userInfo.domain,
              comentary: this.ds_response_text,
              report: this.item
            };
            this.$set(this.item, 'type_flow', 'APPROVE_OWNER');
            this.$set(this.item, 'report_id', this.item.report_id);
            BiReportService.reportInitWorkFlow(_report).then(function (res) {
              if (res && res.code === 200) {
                if (res.success) {
                  tasks.toast.success("Successful request!");
                  if (_this3.$gtm.enabled() && window.dataLayer) {
                    window.dataLayer.push({
                      event: GA_EVENTS.ASSIGN_OPERATOR,
                      object: 'pbi_report',
                      domain_object: _this3.item.domain_org,
                      operator: _this3.stringToHash(_this3.item.data_operator),
                      company_code: _this3.companyCode,
                      id_object: _this3.item.object_name,
                      hash_email: _this3.stringToHash(userInfo.email),
                      module: 'data_platform'
                    });
                  }
                  //this.$toast.success('Successful request')
                  _this3.onCancel();
                } else {
                  tasks.toast.error(res.message);
                  //this.$toast.warning(res.message)
                  _this3.onCancel();
                }
              }
            });
          }
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.APPROVE_OWNER) {
          var data = _objectSpread(_objectSpread({
            response_text: this.response_text,
            domain: window.userInfo.domain
          }, this.item), {}, {
            status: 'APPROVED',
            type_flow: 'APPROVE_OWNER'
          });
          BiReportService.reportSendAssignment(data).then(function (res) {
            if (res.code === 200 && res.success) {
              tasks.toast.success('Done. Now this report will available in "My Reports"');
              //this.$toast.success('Now this report will available in "My Reports"')
              if (_this3.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.OWNERSHIP,
                  object: 'pbi_report',
                  domain_object: _this3.item.domain_org,
                  operator: _this3.stringToHash(_this3.item.data_operator),
                  company_code: _this3.companyCode,
                  id_object: _this3.item.object_name,
                  hash_email: _this3.stringToHash(userInfo.email),
                  module: 'data_platform',
                  status: 'accepted'
                });
              }
              _this3.onCancel();
            } else {
              tasks.toast.error(res.message);
              //this.$toast.warning(res.message)
              _this3.onCancel();
            }
          });
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
          if (JSON.stringify(this.objetoInicial) === JSON.stringify(this.item)) {
            tasks.toast.error("No change has been made to the request");
            //this.$toast.warning("No change has been made to the request")
            return;
          }
          this.$set(this.item, 'type_flow', ACCESS_TYPE_FLOW.CHANGE_METADATA);
          this.$set(this.item, 'report_id', this.item.report_id);
          var _report2 = {
            domain: window.userInfo.domain,
            comentary: this.response_text,
            report: this.item
          };
          BiReportService.reportInitWorkFlow(_report2).then(function (res) {
            if (res && res.code === 200) {
              if (res.success) {
                tasks.toast.success("Successful request!");
                //this.$toast.success('Successful request')
                if (_this3.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS.CHANGE_METADATA,
                    object: 'pbi_report',
                    domain_object: _this3.item.domain_org,
                    operator: _this3.stringToHash(_this3.item.data_operator),
                    company_code: _this3.companyCode,
                    id_object: _this3.item.object_name,
                    hash_email: _this3.stringToHash(userInfo.email),
                    module: 'data_platform'
                  });
                }
                _this3.onCancel();
              } else {
                tasks.toast.error(res.message);
                //this.$toast.warning(res.message)
                _this3.onCancel();
              }
            }
          });
        }
      }
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    onDownloadCsv: function onDownloadCsv() {
      var tplMeta = this.item;
      var columns = ['name'];
      var header = ['organization', 'object_name', 'kdomain', 'ksubdomain', 'data_operator', 'environment', 'path_name', 'object_owner', 'sensitive_data', 'object_description', 'datasource_name'];
      header = header.concat(columns);
      header = header.join(';');
      var body = [];
      body.push(header);
      var dataset = '';
      if (tplMeta.datasets && tplMeta.datasets.length) {
        dataset = tplMeta.datasets[0].object_name;
      }
      var data = [tplMeta.organization, tplMeta.object_name, tplMeta.kdomain, tplMeta.ksubdomain, tplMeta.data_operator, tplMeta.environment, tplMeta.path_name, tplMeta.object_owner, tplMeta.sensitive_data ? 'true' : 'false', tplMeta.object_description, dataset];
      if (tplMeta.pages && tplMeta.pages.length) {
        tplMeta.pages.forEach(function (item) {
          var row = [].concat(data);
          for (var i = 0; i < columns.length; i++) {
            row.push(item[columns[i]]);
          }
          body.push(row.join(';'));
        });
      } else {
        body.push(data.join(';'));
      }
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      var universalBOM = "\uFEFF";
      var encoded = encodeURIComponent(universalBOM + body.join('\n'));
      var url = "data:text/csv; charset=utf-8,".concat(encoded);
      a.href = url;
      a.download = "Report-".concat(tplMeta.path_name, "_").concat(tplMeta.object_name, ".csv");
      a.click();
      window.URL.revokeObjectURL(url);
    },
    onUpdateTabActivate: function onUpdateTabActivate(newTabIndex, oldTabIndex, event) {
      this.txtCancelar = 'Cancel';
      this.showBtnAceptar = true;
      this.showDownloadCsv = true;
      if (newTabIndex === 1) {
        this.showDownloadCsv = false;
      }
      if (newTabIndex >= 2) {
        this.showDownloadCsv = false;
        this.txtCancelar = 'Close';
        this.showBtnAceptar = false;
      }
    }
  }
};